<template>
  <div v-if="unit" class="kiste">
    <h3>{{ unit.name }}</h3>
    <p style="word-wrap: break-word">{{ unit.desc }}</p>
    <img :src="getImgUrl(unit.id)" />
    <div>
      <LifeBar :obj="unit" />
      <Spell :spell="unit.spells[0]" :val="unit.ctick" />
    </div>
    <div :key="buff.uid" v-for="buff in unit.buffs">
      {{ buff.id }}
    </div>
    <div>
      <Minibar
        :color="'purple'"
        style="z-index: 10"
        :val="unit.exp"
        :max="unit.nexp"
        :text="true"
      />
    </div>
  </div>
</template>

<script>
import Spell from "@/components/Spell";
import LifeBar from "@/components/LifeBar";
import Minibar from "./Minibar";

export default {
  name: "Unit",
  components: {
    LifeBar,
    Spell,
    Minibar,
  },
  props: {
    unit: null,
  },
  methods: {
    getImgUrl(id) {
      var images = require.context("../assets/img/enemies", false, /\.webp$/),
        img;
      try {
        img = images("./" + id + ".webp");
      } catch {
        img = images("./blue_slime.webp");
      }
      return img;
    },
  },
};
</script>

<style scoped>
.kiste {
  width: 250px;
  display: flex;
  flex-direction: column;
  background: lightslategray;
  border: 1px solid black;
  padding: 10px;
  align-items: center;
  position: relative;
  height: 430px;
}
.kiste img {
  max-width: 200px;
  width: 100%;
  image-rendering: pixelated;
}
</style>